import clsx from 'clsx'
import { useTranslation } from 'next-i18next'
import { FC, useEffect, useRef, useState } from 'react'
import { useIntersection } from 'react-use'

import Button from '@/components/Button'
import Heading from '@/components/Heading'
import Link from '@/components/Link'
import Picture from '@/components/Picture'

import DefaultComponentProps from '@/types/DefaultComponentProps'

import styles from './Section.module.scss'
import { routes } from '@/config'

export const Platform: FC<DefaultComponentProps> = ({ className = '' }) => {
  const { t, i18n: { language = 'en' } = {} } = useTranslation()

  const [animationStart, setAnimationStart] = useState(false)

  const intersectionRef = useRef(null)

  const intersection = useIntersection(intersectionRef, {
    root: null,
    rootMargin: '0px',
    threshold: 0.4
  })

  useEffect(() => {
    if (intersection?.isIntersecting) {
      setAnimationStart(true)
    }
  }, [intersection?.isIntersecting])

  return (
    <section
      ref={intersectionRef}
      className={clsx(styles['section'], className, {
        [styles['section_animation-start']]: animationStart
      })}
    >
      <div className={styles['section__content']}>
        <div className={styles['section__head']}>
          <Heading className={styles['section__heading']} level={2}>
            {t('platform:heading')}
          </Heading>
          <div className={styles['section__summary']}>
            {t('platform:summary')}
          </div>
        </div>
        <div className={styles['section__fig']}>
          <Picture
            className={styles['section__fig-img']}
            src={[
              { src: `/images/home/${language}/pic1.webp`, type: 'image/webp' },
              { src: `/images/home/${language}/pic1.jpg`, type: 'image/jpeg' }
            ]}
            alt={''}
          />
        </div>
        <div className={styles['section__foot']}>
          <Button
            title={t('forms:buttons.signup.label') as string}
            href={routes.REGISTER}
            as={Link}
            size={'l'}
            className={styles['section__button-link']}
          >
            {t('forms:buttons.learnMore.label')}
          </Button>
          <Button
            title={t('forms:buttons.signin.label') as string}
            href={routes.LOGIN}
            as={Link}
            className={styles['section__button-link']}
            size={'l'}
            variant={'ghost'}
          >
            {t('forms:buttons.fillOutTheBrief.label')}
          </Button>
        </div>
      </div>
    </section>
  )
}
